let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16BzS")).then(() => parcelRequire('8wQna'));